import React, { Component, Fragment } from 'react'
import { Nav } from './includes/'
import { withRouter } from 'react-router-dom'
import Footer from './includes/Footer/Footer'

export default withRouter(
  class Wrapper extends Component {
    render () {
      const { children } = this.props
      return (
        <Fragment>
          <div className="Afrodesiamedia">
            <Nav />
            <div>{children}</div>
          </div>
          <Footer/>
        </Fragment>
      )
    }
  }
)



// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/Wrapper.js